/** Standard suffix appended to every AI News article meta description. */
export const NEWS_ARTICLE_SUFFIX =
  'EWANDS AI News Hub — sharing AI news and analysis for enterprise developers.';

const MAX_SUMMARY_CHARS = 115;

/** First sentence (or trimmed excerpt) + standard news-hub suffix. */
export function buildNewsArticleDescription(excerpt) {
  if (!excerpt || typeof excerpt !== 'string') {
    return `Frontier AI news and analysis. ${NEWS_ARTICLE_SUFFIX}`;
  }

  const trimmed = excerpt.trim();
  const firstSentence = trimmed.match(/^[^.!?]+[.!?]/)?.[0]?.trim() || trimmed;
  const summary =
    firstSentence.length > MAX_SUMMARY_CHARS
      ? `${firstSentence.slice(0, MAX_SUMMARY_CHARS - 1).trim()}…`
      : firstSentence;

  return `${summary} ${NEWS_ARTICLE_SUFFIX}`;
}
